// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { TerceraChartCashItemSeriesDataType } from '../Series/TerceraChartCashItemSeriesEnums';
import { ToolsCache } from '@shared/commons/cache/ToolsCache';
import { CancelActionContext } from '../TerceraChartAction';
import { ScreenPointsConverterFactory } from '../Utils/IScreenPointsConverter';
/// <summary>
/// Создание тулзовин кликами
/// </summary>
export class NewToolClickStrategy {
    constructor(toolBuilder, chart) {
        this.Points = [];
        // билдер тулз
        this.ToolBuilder = toolBuilder;
        this.ApplyNewSnapMode(false);
        // кеш точек
        this.chart = chart;
    }
    Finished() {
        return this.Points.length === this.currentTool.MaxPointsCount();
    }
    Clear() {
        this.Points = [];
        this.toolWindow = null;
        this.currentTool = null;
    }
    /// <summary>
    /// Добавить готовую тлзу в кеш, начать создавать новую
    /// </summary>
    Finish(e) {
        if (this.IsNeedToEdit()) {
            return false;
        }
        this.AddCompletedTool(e);
        return true;
    }
    AddCompletedTool(e) {
        if (this.currentTool == null) {
            return;
        }
        this.currentTool.completed = true;
        const windowToolsRenderer = this.toolWindow != null ? this.toolWindow.GetMainThreadRenderer('TerceraChartToolInstanceRenderer') : null;
        if (windowToolsRenderer != null) {
            // локальная тулза
            windowToolsRenderer.AddTool(this.currentTool, e);
        }
        else {
            // тулза в кеше
            ToolsCache.AddTool(this.currentTool, e);
        }
        this.Clear();
    }
    IsNeedToEdit() {
        const newToolRenderer = this.toolWindow != null ? this.toolWindow.GetMainThreadRenderer('TerceraChartNewToolRenderer') : null;
        if (newToolRenderer == null) {
            return false;
        }
        const view = newToolRenderer.ToolView();
        const editableTool = view;
        if (editableTool != null) {
            if (this.toolWindow != null) {
                view.UpdateScreenPoints(this.toolWindow, this.chart.MainCashItemSeries);
            }
            this.ToolEditing = true;
        }
        return false;
    }
    ToolEdited() {
        if (this.ToolEditing) {
            this.ToolEditing = false;
            this.AddCompletedTool();
            this.GetNextTool();
        }
    }
    /// <summary>
    /// Модификация координт тулзы
    /// </summary>
    /// <param name="window"></param>
    /// <param name="clickPoint"></param>
    /// <param name="offset"></param>
    InitTool(window, clickPoint, offset) {
        // добавить новые точки к динамически расширямому полигону
        this.AddNewPoint(offset);
        const dataType = window == this.chart.mainWindow
            ? this.chart.cashItemSeriesSettings.DataType
            : TerceraChartCashItemSeriesDataType.Absolute;
        for (let i = offset; i < this.currentTool.PointLevel(); i++) {
            const point = this.currentTool.Points[i];
            let x = clickPoint.X;
            let y = clickPoint.Y;
            const refXY = { screenX: x, screenY: y };
            this.screenPoinsConverter.Convert(window, refXY);
            x = refXY.screenX;
            y = refXY.screenY;
            const price = this.chart.cashItemSeriesSettings.RevertConverter(window.PointsConverter.GetDataY(y));
            point[0] = window.PointsConverter.GetDataX(x);
            point[1] = price;
        }
    }
    AddNewPoint(offset) {
        if (offset == this.currentTool.PointLevel() && offset + 1 < this.currentTool.MaxPointsCount()) {
            this.currentTool.AddMorePoints(1);
        }
    }
    // #region INewToolStrategy Members
    CurrentTool() {
        return this.currentTool;
    }
    ToolWindow() {
        return this.toolWindow;
    }
    AddPoint(e, stayInDrawingMode = true) {
        const window = e.window;
        if (!(window === null || window === void 0 ? void 0 : window.ClientRectangle.Contains(e.Location.X, e.Location.Y))) {
            return false;
        }
        const clickPoint = e.Location;
        this.InitTool(window, clickPoint, this.Points.length);
        this.toolWindow = window;
        this.Points.push(clickPoint);
        const currentTool = this.CurrentTool();
        currentTool.addedPointsNum = this.Points.length;
        if (this.Finished() && this.Finish(e)) {
            if (stayInDrawingMode) {
                this.GetNextTool();
            }
            else {
                this.chart.CancelAction(CancelActionContext.RightButton);
            }
        }
        return true;
    }
    GetNextTool() {
        this.currentTool = this.ToolBuilder(this.CurrentType);
    }
    ProcessPosition(e) {
        const window = e.window;
        if (window == null) {
            return false;
        }
        const clickPoint = e.Location;
        this.InitTool(window, clickPoint, this.Points.length);
        return true;
    }
    Cancel(e) {
        if (this.ToolEditing) {
            this.ToolEditing = false;
            this.AddCompletedTool();
            return true;
        }
        if (this.currentTool == null) {
            return false;
        }
        if (this.Points.length >= this.currentTool.MinPointsCount()) {
            // тулза считается законченной
            this.currentTool.RemoveLastPoints(this.currentTool.PointLevel() - this.Points.length);
            this.Finish(e);
        }
        else // тулза неполноценна и удаляется
         {
            this.Clear();
        }
        return true;
    }
    Reset(type) {
        this.CurrentType = type;
        this.currentTool = this.ToolBuilder(type);
    }
    // #endregion
    // #region IDisposable Members
    Dispose() {
        this.chart = null;
        this.Clear();
        this.ToolBuilder = null;
    }
    // #endregion
    // #region ISnapToCandle Members
    ApplyNewSnapMode(useSnap) {
        this.screenPoinsConverter = ScreenPointsConverterFactory.GetScreenPointsConverter(useSnap);
    }
}
